import * as Actions from './scoped-logbook.actions';
import { IScopedLogbookDropdownData } from '../../../shared/component/filter/filter.class';
import { Action } from '@ngrx/store';

export interface IFilterScopedLogbookState {
  isLoading: boolean;
  isLoaded: boolean;
  data: IScopedLogbookDropdownData[];
}

export const initialFilterScopedLogbookState: IFilterScopedLogbookState = {
  isLoaded: false,
  isLoading: false,
  data: [],
};

export function filterScopedLogbookReducer(
  state: IFilterScopedLogbookState = initialFilterScopedLogbookState,
  baseAction: Action,
): IFilterScopedLogbookState {
  const action = baseAction as Actions.FilterScopedLogbookActions;

  switch (action.type) {
    case Actions.GET_SCOPED_LOGBOOKS_FILTER:
      return { ...state, isLoading: true, isLoaded: false };

    case Actions.GET_SCOPED_LOGBOOKS_FILTER_COMPLETED:
      return { ...state, data: action.data, isLoaded: true, isLoading: false };

    case Actions.RESET_SCOPED_LOGBOOK_STORE:
      return {
        ...state,
        isLoaded: false,
        isLoading: false,
        data: [],
      };
    default:
      return state;
  }
}
